import {
  GenerateAsOption,
  GroupByOption,
  PeoplePageSourceDerivedSignalSectionAttributes,
} from 'api/custom-section/types';
import { SourcePageTemplate } from 'api/custom-section/types';
import { SignalConfiguration } from 'api/signal/types';
import { CustomSectionComponentProps } from '../../../types';

export type PeoplePageSourceDerivedSignalSectionComponentProps =
  CustomSectionComponentProps<PeoplePageSourceDerivedSignalSectionAttributes>;
export type PromptInputFormValues = {
  signalConfigurations: Pick<
    SignalConfiguration,
    'signalName' | 'signalConfigurationId'
  >[];
  title: string;
  aiContextChecked: boolean;
  aiContext: string;
  groupBy: GroupByOption;
  generateAs: GenerateAsOption;
  sourcePageTemplates: SourcePageTemplate[];
};
export type Configuration = {
  groupBy: GroupByOption;
  generateAs: GenerateAsOption;
  sourcePageTemplates: SourcePageTemplate[];
};

export const defaultConfiguration: Configuration = {
  groupBy: GroupByOption.TimePeriod,
  generateAs: GenerateAsOption.Bullet,
  sourcePageTemplates: [],
};
